





































import AvaliationComponent from "@/components/Molecules/AvaliationComponent/index.vue";
import { computed, defineComponent, PropType, ref } from "vue";

export default defineComponent({
  components: {
    AvaliationComponent
  },
  props: {
    title: {
      type: String,
      required: true
    },
    protocol: {
      type: String,
      required: false
    },
    detailIcon: {
      type: String,
      default: "bell-on"
    },
    detailTitle: {
      type: String,
      required: true
    },
    detailDescription: {
      type: String,
      required: true
    },
    actionLabel: {
      type: String,
      default: "Concluir"
    },
    avaliation: {
      type: Object as PropType<{
        ticket?: string;
        type: number;
        step: string;
      }>,
      required: false
    }
  },
  emits: ["close", "action"],
  setup(props, { emit }) {
    const avaliacaoRef = ref<InstanceType<typeof AvaliationComponent>>();
    const canContinue = ref(false);
    const isDisabled = computed(() => {
      return props.avaliation ? !canContinue.value : false;
    });

    const onAction = async () => {
      if (props.avaliation) {
        await avaliacaoRef.value.sendAvaliation();
      }
      emit("action");
    };
    return {
      avaliacaoRef,
      canContinue,
      onAction,
      isDisabled
    };
  }
});
